export interface FaqCategory {
  id: string;
  label: string;
}

export interface FaqItem {
  id: string;
  categoryId: string;
  question: string;
  keywords: string;
  paragraphs?: string[];
  list?: string[];
  tip?: string;
}

export const FAQ_CATEGORIES: FaqCategory[] = [
  { id: 'all', label: '전체' },
  { id: 'payment', label: '결제 · 세금' },
  { id: 'sample', label: '샘플 · 생산' },
  { id: 'mold', label: '목형 · 후가공' },
  { id: 'quote', label: '견적 · 상담' },
  { id: 'process', label: '제작과정' },
];

// TODO: 계약금/잔금 비율, 목형 보관 기간, 후가공 단가 등 세부 정책은 실제 운영 기준으로 재확인 후 반영
export const FAQ_ITEMS: FaqItem[] = [
  {
    id: 'q01',
    categoryId: 'payment',
    question: '카드로 결제할 수 있나요?',
    keywords: '카드 결제 링크 토스페이먼츠 세금계산서',
    paragraphs: [
      '네, 가능합니다. 담당자가 안내해 드리는 결제 링크를 통해 온라인 카드 결제를 진행하실 수 있습니다.',
      '세금계산서가 필요하신 경우 결제 전 미리 말씀해 주시면 함께 발행해 드립니다.',
    ],
  },
  {
    id: 'q02',
    categoryId: 'payment',
    question: '견적 결제는 어떤 방식으로 진행되나요?',
    keywords: '계약금 잔금 결제 방식 비율',
    paragraphs: [
      '계약금 납부 후 제작이 시작되며, 잔금은 출고 전 정산하는 방식으로 진행됩니다.',
      '정확한 결제 비율과 일정은 상담 이후 견적서와 함께 안내해 드립니다.',
    ],
  },
  {
    id: 'q03',
    categoryId: 'payment',
    question: '세금계산서 발행과 별도 배송비는 어떻게 처리되나요?',
    keywords: '세금계산서 발행 배송비 방문 수령',
    list: [
      '세금계산서는 요청 시 발행 가능하며, 견적 문의 시 함께 요청해 주세요.',
      '배송비는 박스 형태와 부피에 따라 별도로 안내드립니다.',
      '직접 방문 수령도 가능합니다.',
    ],
  },
  {
    id: 'q04',
    categoryId: 'sample',
    question: '샘플 단계 결과물과 양산품은 품질 차이가 있나요?',
    keywords: '샘플 양산 품질 차이',
    paragraphs: [
      '샘플과 양산품은 제작 공정이 다르기 때문에 미세한 차이가 발생할 수 있습니다.',
      '양산품과 동일한 퀄리티 확인이 꼭 필요하시다면 별도로 요청해 주시면 안내해 드립니다.',
    ],
  },
  {
    id: 'q05',
    categoryId: 'sample',
    question: '샘플에서 확정한 디자인이 양산 단계에서도 그대로 유지되나요?',
    keywords: '샘플 디자인 확정 양산 데이터',
    paragraphs: [
      '네, 최종 승인해 주신 디자인 데이터를 기준으로 양산용 인쇄가 진행됩니다.',
      '데이터 컨펌 이후 오탈자 · 배치 등은 저희 쪽에서도 한 번 더 검수하지만, 최종 확인은 고객님께 한 번 더 부탁드립니다.',
    ],
  },
  {
    id: 'q06',
    categoryId: 'sample',
    question: '소량 제작도 가능한가요?',
    keywords: '소량 제작 최소수량 MOQ',
    paragraphs: ['네, 가능합니다. 친환경 박스는 300개부터, 일반 박스는 500개부터 주문하실 수 있습니다.'],
  },
  {
    id: 'q07',
    categoryId: 'mold',
    question: '목형(톰슨) · 도무송의 보관 정책은 어떻게 되나요?',
    keywords: '목형 톰슨 도무송 보관 기간 폐기',
    paragraphs: [
      '제작에 사용한 목형은 일정 기간 보관해 드리며, 이후 재사용 문의가 없는 경우 폐기될 수 있습니다.',
      '정확한 보관 기간과 재사용 조건은 담당자에게 문의해 주세요.',
      '저희 스튜디오는 맞춤 제작으로만 진행되기 때문에 타사의 목형은 재사용하지 않습니다.',
    ],
  },
  {
    id: 'q08',
    categoryId: 'mold',
    question: '금박 · 부분 UV · 형압 등 후가공 옵션의 비용은 어떻게 책정되나요?',
    keywords: '금박 은박 부분 UV 형압 엠보싱 후가공 가격',
    list: [
      '금박 · 은박 — 인쇄 도수와 별도로 부분 인쇄 비용이 추가됩니다.',
      '부분 UV — 코팅 면적을 기준으로 산정되며, 2곳 이상도 가능합니다.',
      '형압(엠보싱) — 형태 제작비와 별도 가공비가 함께 책정됩니다.',
    ],
    tip: "견적 요청 시 '원하는 후가공 옵션'을 함께 적어주시면 보다 정확한 견적 안내가 가능합니다.",
  },
  {
    id: 'q09',
    categoryId: 'mold',
    question: '다른 회사에서 제작한 박스의 목형을 그대로 재사용할 수 있나요?',
    keywords: '타사 목형 재사용 동일 사례',
    paragraphs: [
      '포트폴리오에 올라와 있는 사례와 유사한 형태로 제작해 드릴 수는 있지만, 모든 사양을 동일하게 가져가더라도 타사의 목형과 도면은 재사용해 드리지 않습니다.',
      '동일한 결과물을 원하시는 경우 새 목형을 처음부터 제작해야 하기 때문에, 본 제작 기간과 비용이 다시 산정됩니다.',
    ],
  },
  {
    id: 'q10',
    categoryId: 'quote',
    question: '견적문의 작성 시 필수로 입력해야 하는 항목은 무엇인가요?',
    keywords: '견적문의 필수항목 업체명 연락처 사이즈 수량',
    list: [
      '업체명 · 이름 · 연락처 · 이메일은 필수 항목입니다.',
      '박스 형태 · 제작 수량 · 박스 사이즈를 함께 적어주셔야 견적 산출이 가능합니다.',
      '내용물 사이즈 · 희망 납기일 · 예산 · 인쇄 사양을 정확히 기재해주실수록 빠른 답변이 가능합니다.',
      '어떤 패키지가 적합할지 고민 중이시라면 예산 범위만 남겨주셔도 담당자가 적합한 방식을 안내해 드립니다.',
    ],
  },
  {
    id: 'q11',
    categoryId: 'quote',
    question: '견적 답변까지 얼마나 걸리나요?',
    keywords: '견적 답변 시간 긴급',
    paragraphs: [
      '남겨주신 견적문의는 담당 디자이너가 직접 확인 후 순차적으로 답변드립니다.',
      "빠른 확인이 필요하신 경우 견적문의 폼의 문의내용에 '긴급'이라고 표시해 주시면 우선적으로 확인해 드립니다.",
    ],
  },
  {
    id: 'q12',
    categoryId: 'quote',
    question: '포트폴리오의 사례와 동일하게 제작이 가능한가요?',
    keywords: '포트폴리오 사례 동일 제작',
    paragraphs: [
      '포트폴리오의 형태 · 마감 · 인쇄 톤은 참고하실 수 있습니다.',
      '다만 특정 브랜드를 위해 제작된 목형과 디자인은 그대로 재사용하지 않으며, 동일한 결과물을 원하시는 경우 새 목형을 처음부터 제작해야 합니다.',
      '포트폴리오에서 참고하고 싶은 사례를 확인하신 뒤 견적문의를 남겨주시면 담당자가 예시와 함께 안내해 드립니다.',
    ],
  },
  {
    id: 'q13',
    categoryId: 'process',
    question: '박스 제작 과정은 어떻게 진행되나요?',
    keywords: '제작과정 단계 상담 시안 샘플 생산',
    list: [
      '상담 & 컨셉 미팅 — 브랜드 톤, 컬러 팔레트, 박스 형태, 예산 범위를 함께 정리합니다.',
      '2D · 3D 시안 구축 — 패키지 형태를 3D 렌더링으로 미리 확인하실 수 있도록 제공합니다.',
      '실물 샘플 제작 — 슬리브 · 트레이 · 리본 등 핵심 디테일의 실제 샘플을 제출합니다.',
      '본 생산 & 납품 — 자체 공장 운영으로 정직한 가격, 빠른 납기, 안정적인 품질을 보장합니다.',
    ],
    tip: '시안 확정 이후 본 생산까지는 약 14일 정도 소요됩니다.',
  },
];
